module.exports = __webpack_public_path__ + "img/close.1295e588.svg";